<template>
  <div class="time-picker-container">
    <VueDatePicker
      ref="picker"
      v-model="internalValue"
      time-picker
      :is-24="true"
      :auto-apply="true"
      :minutes-increment="minutesIncrement"
      :minutes-grid-increment="minutesIncrement"
      :locale="locale"
      :clearable="false"
      :disabled="disabled"
      @update:model-value="handleUpdate"
    >
      <template #trigger>
        <div class="input-group" :class="{ disabled: disabled }">
          <input
            type="text"
            class="form-control not-readonly"
            readonly
            :value="display"
            :placeholder="placeholder"
          />
          <span class="input-group-text">
            <BaseIcon name="clock" />
          </span>
        </div>
      </template>
    </VueDatePicker>
  </div>
</template>

<script>
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import BaseIcon from "@/components/icons/BaseIcon";

/**
 * Óra-választó a `HH:mm` szöveges értékhez.
 * A modelValue kifelé mindig "HH:mm" string marad, befelé a
 * @vuepic/vue-datepicker { hours, minutes } alakját használjuk.
 */
export default {
  name: "TimePicker",
  components: { VueDatePicker, BaseIcon },
  props: {
    modelValue: String,
    placeholder: {
      default: "--:--",
      type: String,
    },
    minutesIncrement: {
      default: 5,
      type: Number,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  emits: ["update:modelValue", "change"],
  data() {
    return {
      internalValue: this.parse(this.modelValue),
    };
  },
  computed: {
    locale() {
      return this.$i18n?.locale || "en";
    },
    display() {
      if (!this.internalValue) return "";
      return (
        this.pad(this.internalValue.hours) +
        ":" +
        this.pad(this.internalValue.minutes)
      );
    },
  },
  watch: {
    modelValue(val) {
      if (val === this.display) return;
      this.internalValue = this.parse(val);
    },
  },
  methods: {
    pad(n) {
      return String(Number(n) || 0).padStart(2, "0");
    },
    parse(val) {
      if (!val) return null;
      const [h, m] = String(val).split(":");
      const hours = Number(h);
      const minutes = Number(m);
      if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
      return { hours, minutes, seconds: 0 };
    },
    handleUpdate(val) {
      this.internalValue = val;
      this.$emit("update:modelValue", this.display);
      this.$emit("change", this.display);
    },
  },
};
</script>

<style scoped>
.time-picker-container {
  width: 100%;
}
.time-picker-container .input-group {
  cursor: pointer;
}
.time-picker-container .input-group.disabled {
  opacity: 0.6;
  pointer-events: none;
}
.time-picker-container input {
  cursor: pointer;
}
.time-picker-container .input-group-text {
  color: var(--gray-light);
  padding: 0 !important;
}
.time-picker-container .input-group-text svg {
  width: 18px;
  height: 18px;
}
</style>
